import React, { Component } from 'react';
import { Route, BrowserRouter as Router, Switch } from 'react-router-dom'


import PageEventos from './PageEventos'
import PagePresenca from './PagePresenca';


import './App.css';

class App extends Component {


  render() {


    return (
      <div>
       
        <Router>
          <Switch>
            <Route exact path="/presenca/:t/tipo/:tipocongresso" component={PagePresenca} />
            <Route exact path="/tk/:t?" component={PageEventos} />
            <Route exact path="/:id/:c?" component={PageEventos} />
          </Switch>
        </Router>

        <footer>
          <div className="container">
            <span className="logo-footer">
              <a href="">
                <img src="styles/images/logo-ceub-nova.png" alt=""/>
              </a>
            </span>
            <div className="contact">
              Contato: (61) 3966-1201 - E-mail: <a href="mailto:central.atendimento@uniceub.br">central.atendimento@uniceub.br</a>
            </div>
            <div className="social">
              <ul>
                <li><a href="https://www.facebook.com/uniceub" rel="noopener noreferrer" target="_blank"><img src="styles/images/icon_facebook.png" alt=""/></a></li>
                <li><a href="https://twitter.com/UniCEUB_Oficial" rel="noopener noreferrer" target="_blank"><img src="styles/images/icon_twitter.png" alt=""/></a></li>
                <li><a href="https://www.linkedin.com/school/uniceub-centro-universitario-de-brasilia/?originalSubdomain=pt" rel="noopener noreferrer" target="_blank"><img src="styles/images/icon_linkedin.png" alt=""/></a></li>
                <li><a href="http://instagram.com/uniceub_oficial" rel="noopener noreferrer" target="_blank"><img src="styles/images/icon_instagram.png" alt=""/></a></li>
                <li><a href="https://www.youtube.com/user/uniceub" rel="noopener noreferrer" target="_blank"><img src="styles/images/icon_youtube.png" alt=""/></a></li>
              </ul>
            </div>
          </div>
          {/* <span className="legal">@2018 - Todos os direitos reservados criação e desenvolvimento - <a href="https://www.chleba.net/" target="_blank" rel="nofollow noopener noreferrer">Chleba Agência digital</a></span> */}
        </footer>
      </div>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js